import fetcher from "src/api/fetcher";

export const queryKey = "sessionData";

export const getSessionData = fetcher.path("/users/me").method("get").create();
